import { render, staticRenderFns } from "./return-form-component.vue?vue&type=template&id=75788cec&scoped=true"
import script from "./return-form-component.vue?vue&type=script&lang=js"
export * from "./return-form-component.vue?vue&type=script&lang=js"
import style0 from "./return-form-component.vue?vue&type=style&index=0&id=75788cec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75788cec",
  null
  
)

export default component.exports